import partner from "~/utils/partner";

const checkApiByParnerId = () => {
  const hostname = window.location.hostname;
  if (hostname.includes("beta")) {
    return "https://api-121.medpro.com.vn";
  }
  if (hostname.includes("hotfix")) {
    return "https://api-hotfix.medpro.com.vn";
  }
  switch (partner) {
    case "umc":
      return "https://api-119.medpro.com.vn";

    default:
      return "https://api-v2.medpro.com.vn";
  }
};

const checkApiLogin = () => {
  const hostname = window.location.hostname;

  if (hostname.includes("hotfix")) {
    return `https://id-v121.medpro.com.vn/check-phone`;
  }
  if (hostname.includes("beta")) {
    return `https://id-v121.medpro.com.vn/check-phone`;
  }

  switch (partner) {
    default:
      return `https://id-v121.medpro.com.vn/check-phone`;
  }
};

// Api backend
export const RESTFULL_API_URL = checkApiByParnerId();
export const MEDPRO_LOGIN = checkApiLogin();

// Api hình ảnh và nội dung
export const STATIC_CONTENT_API_URL = `https://resource.medpro.com.vn`;

export const COOKIE_EXPIRES = 43200;

// wechat
export const SOCKET_CHAT = "wss://alpha-api.medpro.com.vn/cable";

// link thanh toán paymenthub
export const PAYMENT_HUB_URL =
  "https://payment-gateway-qrcode-testing.medpro.com.vn";

export const LINK_API_COVID19 = "https://covid19-vaccine.medpro.com.vn";

export const BO_API = "https://bo-api-testing.medpro.com.vn";
